import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import cs from './cs.json'
import en from './en.json'
import { readSettings } from '@/state/settingsPersist'

const LOCALE_FROM_SETTINGS = readSettings()?.locale ?? 'cs'

void i18n.use(initReactI18next).init({
  resources: {
    cs: { translation: cs },
    en: { translation: en },
  },
  lng: LOCALE_FROM_SETTINGS,
  fallbackLng: 'cs',
  interpolation: { escapeValue: false },
  returnNull: false,
})

export default i18n
